import React from "react";
import {checkLockStatus} from "../compare/compare.method";
import CloseIcon from "@mui/icons-material/Close";
import Carousel from "react-bootstrap/Carousel";
import {getVehicleDetails} from "./photos.utils";
import {currencyConverter} from "../../utility/methods";
import {Color} from "../compare/Color";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Change} from "../compare/Change";
import LockCompetitor from "../Button/LockCompetitor";
import {faUpRightAndDownLeftFromCenter} from "@fortawesome/free-solid-svg-icons";
import Loader from "../Loader/Loader";

const SecondaryCompetitors = ({
                                  vehicle,
                                  id,
                                  removeVehicle,
                                  isLocked,
                                  t,
                                  getVehicleImage,
                                  activeLocale,
                                  secondaryEnlargeView,
                                  changeHandler,
                                  vehicleData,
                                  setVehicleData,
                                  openModal,
                                  setOpenModal,
                                  handleModalClose,
                                  secondaryYear,
                                  vehiclesMakes,
                                  vehicleModel,
                                  trimModel,
                                  setTrimModel,
                                  setVehicleModel,
                                  setVehicleMake,
                                  vehiclesTrim,
                                  vehicleIndex,
                                  vehicleTypeName,
                                  driveType,
                                  setDriveType,
                                  trimCodes,
                                  handleToggle,
                                  dispatch,
                                  isMobile,
                                  isLoading,
                                  handleClick,
                                  isMobileHeight,
                                  headerLoadType
                              }) => {
    const vehicleCTA = "https://www.jdpower.com/cars-for-sale/make-"+ vehicle?.make.toLowerCase() + "/model-" + vehicle?.model.toLowerCase().replace(/ /g, "-")

    return (
        <div className={"secondaryVehicle"}>
                <button
                    type="button"
                    className={"close-compare"}
                    id={"photos-vehicle-remove"}
                    onClick={() => removeVehicle(vehicle, id)}
                    disabled={checkLockStatus(vehicle, isLocked, id)}
                    title={
                        checkLockStatus(vehicle, isLocked, id)
                            ? t("overview.changeSelectModal.vehicleLocked")
                            : null
                    }
                >
                    <CloseIcon fontSize={"medium"}/>
                </button>

            <div className={"competitor-image-container"}>
                <div className={'competitor-image'} onClick={() => handleClick(id, dispatch, isMobile, isMobileHeight)}>
                    {isLoading && isLoading[id] ? (
                        <div className="competitor-loader-container">
                            <Loader isMobile={isMobile || isMobileHeight } isSwappedClicked={true}/>
                        </div>
                    ) : (
                        <Carousel indicators={false} interval={null} controls={false} slide={false}>
                            {vehicle && vehicle.media && getVehicleImage(Object.values(vehicle.media[Object.keys(vehicle.media)[0]]), vehicle)}
                        </Carousel>
                    )}
                </div>
            </div>

            <div className={'competitor-details'}>
                <div className={'competitor-title'}>
                    {getVehicleDetails(vehicle)}
                </div>
                {vehicle && (
                    <div className={'competitor-price'}>
                        {t('overview.startingFrom')} {""}
                        {currencyConverter(vehicle?.pricing.msrp, activeLocale)}
                    </div>
                )}

                {headerLoadType != null && vehicle && (
                    <div className={"vehicle-CTA secondary-CTA"}>
                        <a target="_blank" href={vehicleCTA}>See Cars For Sale</a>
                    </div>
                )}
                <div className={'change-section'}>
                    <div className={'color-container'}>
                        <Color
                            primaryColor={vehicle?.colors?.exteriors}
                            translate={t}
                            id={id}
                            mediaColor={vehicle?.currentColor}
                            interiorColor={vehicle?.colors?.interiors}
                        />

                        <button
                            id={id}
                            className={'btn-default enlarge-btn-secondary'}
                            onClick={(event) => secondaryEnlargeView(id, vehicle)}
                        >
              <span className="photos-enlarge-button">
                <FontAwesomeIcon icon={faUpRightAndDownLeftFromCenter}/>
              </span>
                        </button>
                    </div>
                    <div className={'change-container'}>
                        <button
                            id={id}
                            className={
                                checkLockStatus(vehicle, isLocked, id)
                                    ? "btn-default btn-change-disabled"
                                    : "btn-default btn-change-compare"
                            }
                            value={vehicle}
                            onClick={(event) => changeHandler(id, vehicle)}
                            disabled={isLocked && isLocked[id]}
                        >
                            {vehicle ? t('overview.changeSelectModal.change') : t('overview.controls.selectVehicle')}
                        </button>

                        <Change
                            vehicleData={vehicleData}
                            setVehicleData={setVehicleData}
                            openModal={openModal}
                            handleModalClose={handleModalClose}
                            years={secondaryYear}
                            vehicleMake={vehiclesMakes}
                            vehicleModels={vehicleModel}
                            trimModel={trimModel}
                            setTrimModel={setTrimModel}
                            setVehicleModel={setVehicleModel}
                            setVehicleMake={setVehicleMake}
                            vehiclesTrim={vehiclesTrim}
                            vehicleIndex={vehicleIndex}
                            vehicleTypeName={vehicleTypeName}
                            driveType={driveType}
                            setDriveType={setDriveType}
                            lockedVehicle={isLocked}
                            setOpenModal={setOpenModal}
                        />
                        <LockCompetitor
                            isLocked={isLocked}
                            vehicle={vehicle}
                            vehicleIndex={id}
                            trimCodes={trimCodes}
                            toggleLock={() => handleToggle(id, vehicle)}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SecondaryCompetitors;
